<div class="body">
    <br />
    <div class="container principal">
        <div class="col-lg-12">
            <p>Circular N° 3623 de fecha 18.10.2021, Superintendencia de Seguridad Social. <b>Los afiliados deben
                    conservar los originales de los documentos </b>
                <br />
                <b>de respaldo de los beneficios solicitados digitalmente al Servicio de Bienestar, por el plazo de 5
                    años</b>
                <br />
                <b> conforme a los Artículos N° 2514 y 2515 del Código Civil.</b> Dictamen N° 467/2021.
            </p>
            <br />
            <p><b>Requisitos Beneficio: </b> <a
                    href="{{this.linkTexto}}"
                    target="_blank">Ayuda
                    Médica</a>.</p>
        </div>
    </div>
    <br />
    <div class="row">

        <div class="col-lg-5"> </div>

        <div class="center">
            <h1> Ayuda Médica</h1>

        </div>

        <div class="col-lg-4"> </div>

    </div>

    <div class="container">

        <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

            <div class="row">

                <div class="col-lg-1"> </div>
                <div class="col-lg-2">
                    <h1> Rut Afiliado </h1>
                </div>

                <div class="col-lg-6">
                    <h2 id="txt_rut" name="afiliado">
                        {{this.afiliado.rutAfiliado}}
                    </h2>
                </div>

            </div>

        </div>

        <div *ngIf="rol != 'ROLE_AFILIADO'" style="padding-bottom: 20px;">

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-2">
                    <h1> Rut Afiliado </h1>
                </div>

                <div class="col-lg-6">

                    <input id="rutAfiliado" name="rutAfiliado" [(ngModel)]="documentosAyuda.rutAfiliado"
                        #afiliado="ngModel" class="form-control" type="text" required
                        placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1"
                        pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1">

                    <button class="btn btn-primary" id="btnvalida" (click)="ingresaAfiliado()"
                        [disabled]="afiliado.invalid ">

                        Buscar

                    </button>

                </div>

                <div class="col-lg-1"> </div>

            </div>


            <br />

        </div>
        <br />
        <form #ayudaMedicaForm=ngForm>
            <div class="table-responsive">

                <table class="table">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope="col"> Rut </th>

                            <th scope="col"> Nombre y Apellido </th>

                            <th scope="col"> Parentesco </th>

                            <th scope="col"> Edad </th>

                            <th scope="col"> Sexo </th>

                            <th scope="col"> Seleccionar </th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'"
                            *ngFor="let postulante of postulantes; let i = index">

                            <td> {{postulante.rut + '-' + postulante.dv}} </td>

                            <td> {{postulante.nombres + ' ' + postulante.apellidoPaterno }} </td>

                            <td> {{postulante.parentesco}} </td>

                            <td> {{postulante.fechaNacimiento}} </td>

                            <td> {{postulante.sexo.nombre}} </td>

                            <td>
                                <!-- 
                                <input type="radio" name="postulante" [(ngModel)]="documentosAyuda.beneficiario" value="{{i}}" required>
                                -->
                                <input type="radio" name="postulante" [(ngModel)]="ayuda.beneficiario"
                                    (click)="esconderBeneficiarios(postulante.parentesco)" value="{{i}}" required>

                            </td>

                        </tr>

                    </tbody>

                </table>


            </div>
            <br />
            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-4">
                    <h2> Datos de Ayuda Médica </h2>
                </div>

                <div class="col-lg-4"> </div>

            </div>

            <br />


            <div class="row">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <label>
                        <p> Tipo de Evento </p>
                    </label>
                </div>

                <div class="col-lg-5">
                    <div class="form-group">
                        <mat-select [(ngModel)]="documentosAyuda.tipoEvento" required id="tipoEvento" class="form-control" name="tipoEvento"
                            #tipoEvento="ngModel" ng-model-options="{updateOn: 'submit'}">
                            <mat-option *ngFor="let evento of this.eventos" value="{{evento.id}}">
                                {{evento.descripcion}}
                            </mat-option>

                        </mat-select>
                    </div>
                </div>
                <div *ngIf="!tipoEvento.errors?.pattern" class="col-lg-3"> </div>
                <div *ngIf="tipoEvento.errors?.pattern" class="alert alert-danger">

                    <div> Seleccione un tipo de evento médico </div>

                </div>
            </div>
            <br />


            <div class="row">

                <div class="col-lg-1"> </div>
                <div class="col-lg-3"> <label> Tipo de Documento </label> </div>
                <div class="col-lg-5">
                    <div class="form-group">
                        <mat-select name="tipoDocumento" id="tipoDocumento" class="form-control" required
                            [(ngModel)]="documentosAyuda.tipoDocumento" #tipoDocumento="ngModel"
                            ng-model-options="{updateOn: 'submit'}">

                            <mat-option *ngFor="let tipoDocumento of this.tiposDocumento" value="{{tipoDocumento}}">

                                {{tipoDocumento}}

                            </mat-option>

                        </mat-select>

                    </div>
                </div>
                <div *ngIf="!tipoDocumento.errors?.pattern" class="col-lg-3"> </div>
                <div *ngIf="tipoDocumento.errors?.pattern" class="alert alert-danger">

                    <div> Seleccione un tipo de documento </div>

                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <p> Fecha de Documento </p>
                </div>
                <div class="col-lg-5">
                    <input class="form-control" name="fechaDocumento" id="fechaDocumento" required
                        #fechaDocumento="ngModel" [(ngModel)]="documentosAyuda.fechaDocumento" type="date"
                        ng-model-options="{updateOn: 'submit'}">
                </div>
                <div class="col-lg-3"> </div>
            </div>
            <br />
            <div class="row">

                <div class="col-lg-1"> </div>


                <div class="col-lg-3">
                    <p> Folio de Documento </p>
                </div>


                <div class="col-lg-5">

                    <input class="form-control" name="nroDocumento" required #nroDocumento="ngModel"
                        [(ngModel)]="documentosAyuda.nroDocumento" type="text" (keypress)="numberOnly($event)"
                        autocomplete=off onPaste="return false">

                </div>

                <div class="col-lg-3"> </div>

            </div>
            <br />
            <div class="row">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <p> Rut Prestador </p>
                </div>
                <div class="col-lg-5">
                    <input id="txt_rutPrestador" name="rutPrestador" [(ngModel)]="documentosAyuda.rutPrestador"
                        #rutPrestador="ngModel" class="form-control" type="text" required type="text"
                        placeholder="Ingrese el RUT del prestador. Ej: 11111111-1"
                        pattern="[0-9]{7,10}[-]{1}[0-9Kk]{1}" />
                </div>
                <div *ngIf="!rutPrestador.errors?.pattern" class="col-lg-3"> </div>
                <div *ngIf="rutPrestador.errors?.pattern" class="alert alert-danger">
                    <div> RUT del prestador. Ej: 11111111-1 </div>
                </div>
            </div>
            <br />
            <div class="row ">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3">
                    <p> Diagnóstico </p>
                </div>
                <div class="col-lg-5">
                    <textarea name="diagnostico" id="diagnostico" #diagnostico="ngModel" required
                        [(ngModel)]="documentosAyuda.diagnostico" cols="55" rows="5"
                        (ngModelChange)="documentosAyuda.diagnostico = $event.toUpperCase()"></textarea>

                </div>

                <div class="col-lg-3"> </div>
                <div *ngIf="!diagnostico.errors?.pattern" class="col-lg-3"> </div>
                <div *ngIf="diagnostico.errors?.pattern" class="alert alert-danger">

                    <div> Ingrese el Diagnóstico. </div>

                </div>
            </div>
            <br />
            <div class="row ">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Tratamiento </p>
                </div>

                <div class="col-lg-5">

                    <textarea name="tratamiento" id="tratamiento" #tratamiento="ngModel" required
                        [(ngModel)]="documentosAyuda.tratamiento" cols="55" rows="5"
                        (ngModelChange)="documentosAyuda.tratamiento = $event.toUpperCase()"></textarea>

                </div>

                <div class="col-lg-3"> </div>
                <div *ngIf="!tratamiento.errors?.pattern" class="col-lg-3"> </div>
                <div *ngIf="tratamiento.errors?.pattern" class="alert alert-danger">

                    <div> Ingrese el Tratamiento. </div>

                </div>
            </div>
            <br />
            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3"> <label> Sistema de Salud </label> </div>

                <div class="col-lg-5">

                    <div class="form-group">

                        <mat-select name="sistemaSalud" id="sistemaSalud" class="form-control" required
                            [(ngModel)]="documentosAyuda.sistemaSalud" #sistemaSalud="ngModel"
                            (selectionChange)="muestraOtro()">

                            <mat-option *ngFor="let sis of this.sistema" value="{{sis.id}}">

                                {{sis.descripcion}}

                            </mat-option>

                        </mat-select>

                    </div>


                </div>
                <div *ngIf="!sistemaSalud.errors?.pattern" class="col-lg-3"> </div>
                <div *ngIf="sistemaSalud.errors?.pattern" class="alert alert-danger">

                    <div> Seleccione un Sistema de Salud. </div>

                </div>
            </div>
            <br />

            <div class="row" *ngIf="otro == true">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3"> <label> Otro Sistema de Salud </label> </div>
                <div class="col-lg-5">
                    <input id="otroSistemaSalud" name="otroSistemaSalud" #nombres="ngModel"
                        [(ngModel)]="documentosAyuda.otroSistemaSalud" class="form-control" required type="text"
                        placeholder="Ingrese otro tipo de Sistema de Salud" />
                </div>
                <div class="col-lg-3"> </div>
            </div>
            <br />

            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3"> <label> Protección de Salud </label> </div>

                <div class="col-lg-5">

                    <div class="form-group">

                        <mat-select name="proteccionSalud" id="proteccionSalud" class="form-control" required multiple
                            [(ngModel)]="documentosAyuda.proteccionSalud" #proteccionSalud="ngModel"
                            (selectionChange)="muestraOtroProteccionSalud()">

                            <mat-option *ngFor="let pro of this.proteccion" value="{{pro.id}}">

                                {{pro.descripcion}}

                            </mat-option>

                        </mat-select>

                    </div>


                </div>
                <div *ngIf="!proteccionSalud.errors?.pattern" class="col-lg-3"> </div>
                <div *ngIf="proteccionSalud.errors?.pattern" class="alert alert-danger">

                    <div> Seleccione una Protección de Salud. </div>

                </div>
            </div>
            <br />
            <div class="row" *ngIf="otroProteccionSalud == true">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3"> <label> Otro Protección de Salud </label> </div>
                <div class="col-lg-5">
                    <input id="otroProteccion" name="otroProteccion" #nombres="ngModel"
                        [(ngModel)]="documentosAyuda.otroProteccion" class="form-control" required type="text"
                        placeholder="Ingrese otro tipo de Protección de Salud" />
                </div>
                <div class="col-lg-3"> </div>
            </div>
            <br />

            <div class="row ">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Monto Total del Gasto </p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" name="montoTotalGasto" id="montoTotalGasto" required type="number"
                        autocomplete=off (keypress)="numberOnly($event)" #montoTotalGasto="ngModel"
                        [(ngModel)]="documentosAyuda.montoTotalGasto" (change)="calculaMontoCopago()">

                </div>

                <div class="col-lg-3"> </div>

            </div>
            <br />

            <div class="row ">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Monto Reembolso Sistema Salud (Fonasa/Isapre)</p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" name="montoReembolso" id="montoReembolso" required type="number"
                        autocomplete=off (keypress)="numberOnly($event)" #montoReembolso="ngModel"
                        [(ngModel)]="documentosAyuda.montoReembolso" (change)="calculaMontoCopago()">

                </div>

                <div class="col-lg-3"> </div>

            </div>
            <br />

            <div class="row ">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Monto Reembolso de Bienestar o Cía. Seguro </p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" name="montoReembolsoSistema" id="montoReembolsoSistema" required
                        type="number" autocomplete=off (keypress)="numberOnly($event)" #montoReembolsoSistema="ngModel"
                        [(ngModel)]="documentosAyuda.montoReembolsoSistema" (change)="calculaMontoCopago()"
                        placeholder=0>

                </div>

                <div class="col-lg-3"> </div>

            </div>
            <br />
            <div class="row ">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Monto Otro Reembolso </p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" name="montoOtroReembolso" id="montoOtroReembolso" required type="number"
                        autocomplete=off (keypress)="numberOnly($event)" #montoOtroReembolso="ngModel"
                        [(ngModel)]="documentosAyuda.montoOtroReembolso" (change)="calculaMontoCopago()" placeholder=0>

                </div>

                <div class="col-lg-3"> </div>

            </div>
            <br />
            <div class="row ">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Monto Copago Total </p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" name="montoCopago" id="montoCopago" required #montoCopago="ngModel"
                        [(ngModel)]="documentosAyuda.montoCopago" type="number" (keypress)="numberOnly($event)"
                        autocomplete=off disabled value="ayuda.montoCopago">

                </div>

                <div class="col-lg-3"> </div>

            </div>
            <br />


        </form>
        <div class="row">

            <div class="col-lg-2 col-sm-2"> </div>

            <div class="col-lg-6 col-sm-1"> </div>

            <div class="col-lg-3 col-sm-1">
                <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'">
                    <button class="btn btn-success" (click)="agregarAyudaMedica(ayudaMedicaForm)"
                        [disabled]="ayudaMedicaForm.invalid">
                        Agregar
                    </button>
                </div>
            </div>
            <div class="col-lg-1 col-sm-1"> </div>
        </div>
        <br />
        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-4">
                <h2> Listado de Documentos </h2>
            </div>

            <div class="col-lg-4"> </div>

        </div>

        <br />
        <form #solicitudAyudaForm=ngForm>
            <div class="table-responsive">

                <table class="table">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope="col"> Tipo Evento</th>
                            <th scope="col"> Tipo Documento</th>
                            <th scope="col"> Folio Documento</th>
                            <th scope="col"> Fecha Documento</th>
                            <th scope="col"> Diagnóstico</th>
                            <th scope="col"> Tratamiento</th>
                            <th scope="col"> Protección Salud</th>
                            <th scope="col"> Monto Total Gasto </th>
                            <th scope="col"> Monto Reembolso</th>
                            <th scope="col"> Monto Reembolso Sistema</th>
                            <th scope="col"> Monto Otro Reembolso</th>
                            <th scope="col"> Monto Copago </th>
                            <th scope="col"> Documento </th>
                            <th scope="col"> </th>



                        </tr>

                    </thead>

                    <tbody>
                        <tr [class]="'rowEven' " *ngFor="let ay of this.ayudaMedica">
                            <td>{{ay[0].tipoEvento}}</td>
                            <td>{{ay[0].tipoDocumento}}</td>
                            <td>{{ay[0].nroDocumento}}</td>
                            <td>{{ay[0].fechaDocumento}}</td>
                            <td>{{ay[0].diagnostico|slice:0:10}} </td>
                            <td>{{ay[0].tratamiento|slice:0:10}}</td>
                            <td>{{ay[0].proteccionSalud}}</td>
                            <td>{{ay[0].montoTotalGasto}}</td>
                            <td>{{ay[0].montoReembolso}}</td>
                            <td>{{ay[0].montoReembolsoSistema}}</td>
                            <td>{{ay[0].montoOtroReembolso}}</td>
                            <td>{{ay[0].montoCopago}}</td>
                            <td>
                                <button mat-button class="mat-raised-button btn-dark"
                                    (click)="eliminarAyuda(ay[0].montoCopago,ay[0].montoTotalGasto,ay[0].idInterno)">
                                    <i class="fa fa-trash"> </i> Eliminar
                                </button>
                            </td>
                        </tr>

                    </tbody>

                </table>

            </div>
        </form>
        <br />


        <div class="row ">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Monto Total Copago </p>
            </div>

            <div class="col-lg-5">

                <input class="form-control" name="totalCopago" [(ngModel)]="ayuda.totalCopago" type="number"
                    (keypress)="numberOnly($event)" autocomplete=off disabled>

            </div>

            <div class="col-lg-3"> </div>

        </div>
        <br />
        <div class="row ">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Total a pagar </p>
            </div>

            <div class="col-lg-5">

                <input class="form-control" name="totalPagar" [(ngModel)]="ayuda.totalPagar" type="number"
                    (keypress)="numberOnly($event)" autocomplete=off disabled>

            </div>

            <div class="col-lg-3"> </div>

        </div>
        <br />
        <div class="row ">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest"
                    (change)="seleccionaArchivo($event, 0)">

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>
            <div class="col-lg-1"> </div>

        </div>
        <br />

        <div *ngIf="cantidadArchivos > 1" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (2) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo2" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest2"
                    (change)="seleccionaArchivo($event, 1)">
            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 2" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (3) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo3" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest3"
                    (change)="seleccionaArchivo($event, 2)">
            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 3" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (4) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo4" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest4"
                    (change)="seleccionaArchivo($event, 3)">

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 4" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (5) </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo5" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest5"
                    (change)="seleccionaArchivo($event, 4)">
            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 5" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (6) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo6" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest"
                    (change)="seleccionaArchivo($event,5)">

            </div>

            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>
            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 6" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (7) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo6" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest"
                    (change)="seleccionaArchivo($event,6)">

            </div>

            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>
            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 7" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (8) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo6" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest"
                    (change)="seleccionaArchivo($event,7)">

            </div>

            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>
            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 8" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (9) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo6" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest"
                    (change)="seleccionaArchivo($event,8)">

            </div>

            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>
            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 9" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (10) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo6" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest"
                    (change)="seleccionaArchivo($event,9)">

            </div>

            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>
            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 10" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (11) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo6" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest"
                    (change)="seleccionaArchivo($event,10)">

            </div>

            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>
            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 11" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (12) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo6" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest"
                    (change)="seleccionaArchivo($event,11)">

            </div>

            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>
            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 12" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (13) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo6" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest"
                    (change)="seleccionaArchivo($event,12)">

            </div>

            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>
            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 13" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (14) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo6" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest"
                    (change)="seleccionaArchivo($event,13)">

            </div>

            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>
            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <div *ngIf="cantidadArchivos > 14" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (15) </p>
            </div>

            <div class="col-lg-5">
                <input type="file" class="form-control-file" name="archivo6" required
                    accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="ayuda.archivoTest"
                    (change)="seleccionaArchivo($event,14)">

            </div>

            <div class="col-lg-2"> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>


        <div class="row line">

            <div class="col-lg-5"> </div>

            <div class="col-lg-6">
                <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'">
                    <button class="btn btn-success" (click)="solicitarAyudas()" [disabled]="procesando">
                        Solicitar
                    </button>
                    ** Recuerde haber anexado todos los archivos
                </div>
            </div>

            <div class="col-lg-1 col-sm-1"> </div>

        </div>
    </div>

    <div class="container" style="height:100px"> </div>

</div>